import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Context
import { AuthProvider } from './contexts/AuthContext';

// Layout & Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import HutsPage from './pages/HutsPage';
import HutDetailsPage from './pages/HutDetailsPage';
import ProfilePage from './ProfilePage';
import LoginPage from './pages/LoginPage';
import GroupsPage from './GroupsPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div id="app-root">
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected Routes inside Layout */}
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<HutsPage />} />
              <Route path="huts/:hutId" element={<HutDetailsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="groups" element={<GroupsPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Toaster position="bottom-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;